import { render, staticRenderFns } from "./page-CustomerAnalysis.vue?vue&type=template&id=08ce265f&scoped=true&"
import script from "./page-CustomerAnalysis.vue?vue&type=script&lang=js&"
export * from "./page-CustomerAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./page-CustomerAnalysis.vue?vue&type=style&index=0&id=08ce265f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ce265f",
  null
  
)

export default component.exports